/* This Context Handles all the Global States the App will need, This includes:
  Language,
  User
*/

import React, { createContext } from 'react';

const AppGlobalsContext = createContext();

export default AppGlobalsContext;